export default "/images/8223badb5d5117e7c370f5434ef2a2bc.avif";